import { useTranslation } from 'react-i18next';
import { z } from 'zod';

export const useFormValidationSchema = () => {
  const { t } = useTranslation();

  const formValidationSchema = z.object({
    name: z.string().min(1, t('validation:required')),
    employeesTokens: z.array(z.string()),
  });

  return formValidationSchema;
};
